import React from 'react';
import { defaultTheme } from './themes';
import { getAffiliateDetails } from '../../utils/appUtils';

const ThemeContext = React.createContext({
  theme: defaultTheme,
  affiliateDetails: getAffiliateDetails(),
});
export default ThemeContext;
